module.exports = __webpack_public_path__ + "img/1579f93.svg";